import { render, staticRenderFns } from "./EmpAddAdvisor.vue?vue&type=template&id=3767f42e&"
import script from "./EmpAddAdvisor.vue?vue&type=script&lang=js&"
export * from "./EmpAddAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports